var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',[_c('b-row',[_c('b-col',[_c('h4',[_vm._v("404: File Not Found")]),_c('p',[_vm._v("I'm sorry. The server couldn't find this page.")])])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }